module.exports = __webpack_public_path__ + "f536040f7cec50cfec8ac87d7ba78044.png";